const ACTIONS_QUEUE_KEY = "actionsQueue";

export const COMMON_TASK_ACTION = 'addCommonTask';
export const SWAP_ACTION = 'swap';
export const END_TASK_ACTION = 'endTask';
export const ISSUE_ACTION = 'issue';
export const COACHING_ACTION = 'coaching';
export const RESET_ACTION = 'reset';
export const SET_TASKS_ORDER = 'setTasksOrder';

/* Actions queue type :
 *
 * [
 *   {
 *      "action": "addCommonTask | swap | endTask | issue | coaching | reset",
 *      "params": {...},
 *      "time": datetime,
 *   },
 * ]
 */

export function getActionsQueue() {
    return JSON.parse(localStorage.getItem(ACTIONS_QUEUE_KEY) || "[]")
        .map(a => ({...a, time: new Date(a.time)}))
        .sort((a,b) => a.time.getTime() - b.time.getTime());
};

function saveActionsQueue(actionsQueue) {
    const queue = actionsQueue.map(a => ({...a, time: a.time.toISOString()}))
    localStorage.setItem(ACTIONS_QUEUE_KEY, JSON.stringify(queue));
}

export function addActionInQueue(actionType, params, time) {
    const actionsQueue = getActionsQueue();    
    actionsQueue.push({
        action: actionType,
        params: params,
        time: new Date(time),
    });
    saveActionsQueue(actionsQueue);
    return actionsQueue.length;
};

export function removeActionFromQueue(actionType, time) {
    const actionsQueue = getActionsQueue();
    const newActionsQueue = actionsQueue.filter(
        (a) => a.action !== actionType || a.time.getTime() - time.getTime() !== 0
    );
    if (newActionsQueue.length > 0) {
        saveActionsQueue(newActionsQueue);
    } else {
        localStorage.removeItem(ACTIONS_QUEUE_KEY);
    }
    return newActionsQueue.length;
};

export function invertRunningTimers() {
    const actionsQueue = getActionsQueue();
    const newActionsQueue = actionsQueue.map((a) => {
        if (a.params?.runningTimer) {
            return {
                ...a,
                params: {
                    ...a.params,
                    runningTimer: a.params.runningTimer === 1 ? 2 : 1
                }
            };
        } else if (a.action === SWAP_ACTION) {
            return {
                ...a,
                params: {
                    ...a.params,
                    toRunningTimer: a.params.toRunningTimer === 1 ? 2 : 1
                }
            };
        }
        return a;
    });
    saveActionsQueue(newActionsQueue);
    return newActionsQueue.length;
}